import { Component, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterLink } from '@angular/router';
import { LucideIconsModule } from '../../../shared/lucide-icons.module';
import { ThemeService } from '../../../core/services/theme.service';

@Component({
    selector: 'app-footer',
    standalone: true,
    imports: [CommonModule, RouterLink, LucideIconsModule],
    templateUrl: './footer.component.html',
    styleUrls: ['./footer.component.scss'],
})
export class FooterComponent {
    currentYear = new Date().getFullYear();
    readonly themeService = inject(ThemeService);
    private readonly localLogoBlack = 'https://assetsnibni.zohostratus.com/images/logos/nibni-logo-black.avif';
    private readonly localLogoWhite = 'https://assetsnibni.zohostratus.com/images/logos/nibni-logo-white.avif';

    get logoSrc(): string {
        const isDarkTheme = this.themeService.theme() !== 'white';
        return isDarkTheme ? this.localLogoWhite : this.localLogoBlack;
    }

    footerNavigation = {
        properties: [
            { name: "Browse Properties", href: "/properties" },
            { name: "Featured Projects", href: "/projects" },
            { name: "New Developments", href: "/properties", queryParams: { status: 'new' } },
            { name: "Investment Opportunities", href: "/properties", queryParams: { type: 'investment' } },
        ],
        resources: [
            { name: "FAQ", href: "/faq" },
            { name: "Contact us", href: "mailto:support@nibni.com" },
        ],
        legal: [
            { name: "Terms of Service", href: "/terms" },
            { name: "Privacy Policy", href: "/privacy" },
        ],
    };

    socialLinks = [
        { name: "Facebook", href: "https://www.facebook.com/nibnirealestate", icon: "facebook" },
        { name: "Instagram", href: "https://www.instagram.com/nibnirealestate/", icon: "instagram" },
        { name: "LinkedIn", href: "https://www.linkedin.com/company/nibni/", icon: "linkedin" },
    ];
}
